export default {
  CUSTOMER: 'customer',
  ADMIN: 'user',
};
